import { useState, useEffect } from 'react';

interface IPLocation {
  latitude: number;
  longitude: number;
  city?: string;
  country?: string;
}

export function useIPGeolocation() {
  const [ipLocation, setIpLocation] = useState<IPLocation | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchIPLocation = async () => {
      try {
        // Utilisation de l'API ipapi.co (gratuite, pas besoin de clé API)
        const response = await fetch('https://ipapi.co/json/');
        
        if (!response.ok) {
          throw new Error('Impossible de récupérer la géolocalisation IP');
        }
        
        const data = await response.json();
        
        if (data.latitude && data.longitude) {
          setIpLocation({
            latitude: data.latitude,
            longitude: data.longitude,
            city: data.city,
            country: data.country_name
          });
        } else {
          throw new Error('Données de géolocalisation IP invalides');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erreur inconnue');
        setIpLocation(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchIPLocation();
  }, []);

  return { ipLocation, isLoading, error };
}